var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-row",
            { staticClass: "border", attrs: { "no-margin": "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-number", {
                    style: { flexGrow: 1 },
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("sell-price-interest.add-net-amount"),
                      icon: "euro-sign",
                    },
                    model: {
                      value: _vm.value.AbsolutePriceRule.ToAddAmount,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value.AbsolutePriceRule,
                          "ToAddAmount",
                          $$v
                        )
                      },
                      expression: "value.AbsolutePriceRule.ToAddAmount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-number", {
                    style: { flexGrow: 1 },
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("sell-price-interest.add-net-percent"),
                      icon: "percent",
                    },
                    model: {
                      value: _vm.value.AbsolutePriceRule.ToAddAmountPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value.AbsolutePriceRule,
                          "ToAddAmountPercent",
                          $$v
                        )
                      },
                      expression: "value.AbsolutePriceRule.ToAddAmountPercent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }